import { SelectedOrg } from '../../common/keys';
import { cookie } from '../../common/cookie';

export const getSelectedOrg = () => {
  const org = cookie('get', SelectedOrg);
  if (org) {
    return JSON.parse(org);
  }
  return null;
};

export const isWorkFront = () => {
  const org = getSelectedOrg();
  if (org) {
    return org.type === 'WORKFRONT';
  }
  return false;
};

export const isCommerce = () => {
  const org = getSelectedOrg();
  if (org) {
    return org.type === 'COMMERCE';
  }
  return false;
};


export const isECC = () => {
  let org = getSelectedOrg();
  if (org) {
    return org.type === 'ECC';
  } else {
    return false;
  }
};
